import {
  Modal,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
  Grid,
  Typography,
} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import MDBadgeDot from "components/MDBadgeDot";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import React from "react";
import { generateColorFromString } from "utils/GenerateColorFromString/GenerateColorFromString";
import Loader from "utils/Loader";

const createModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  maxWidth: "550px",
  overflowX: "auto",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 2,
  "& .MuiFormHelperText-root": { color: "#d32f2f" },
  borderRadius: "0.5rem",
  outline: "none",
};

function DailyPointsInformationModal({
  open,
  handleClose,
  actionInfo,
  competition,
  loading,
  showCountAndPoints = true,
}) {
  const theme = useTheme();
  const isMobileDisplay = useMediaQuery(theme.breakpoints.only("xs"));

  const renderKpiRow = (row) => {
    const display = [
      <Grid item display="flex">
        <MDBadgeDot
          size="lg"
          sx={{
            ml: 1,
            p: 0,
            i: {
              background: generateColorFromString(row?.KpiActivity?.name),
            },
          }}
          badgeContent=""
        />
        {row?.KpiActivity?.name}
      </Grid>,
    ];
    if (showCountAndPoints) {
      display.push(
        <Grid item pl={3}>
          <Typography sx={{ fontSize: "1rem" }}>{`${row?.count} ${
            row?.count && row.count === 1 ? "kpi" : "kpis"
          } : ${row?.points} ${row?.points && row.points === 1 ? "point" : "points"}`}</Typography>
        </Grid>
      );
    }
    return display;
  };
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <MDBox sx={createModalStyle}>
        <MDTypography
          sx={{ marginBottom: "1rem", p: 1 }}
          id="modal-modal-title"
          variant="h5"
          component="h2"
        >
          {competition ? "Competition" : "Daily"} points information
        </MDTypography>
        <TableContainer
          component={Paper}
          sx={{
            maxHeight: "100%",
            userSelect: "none",
            overflowY: "auto",
            position: "relative",
            boxShadow: "none",
            borderRadius: 0,
          }}
        >
          <Loader loading={loading} />
          <Table aria-label="simple table">
            {!isMobileDisplay && (
              <TableHead sx={{ display: "table-header-group" }}>
                <TableRow>
                  <TableCell
                    width="100%"
                    sx={{
                      padding: "0.75rem .6rem",
                    }}
                  >
                    KPI
                  </TableCell>
                  {showCountAndPoints && (
                    <>
                      <TableCell
                        align="center"
                        sx={{
                          padding: "0.4rem .5rem",
                        }}
                      >
                        KPIs Completed
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          padding: "0.4rem .6rem",
                        }}
                      >
                        Points Achieved
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          padding: "0.4rem .6rem",
                        }}
                      >
                        Daily Point Limit
                      </TableCell>
                    </>
                  )}
                </TableRow>
              </TableHead>
            )}
            <TableBody>
              {actionInfo?.map((row) => (
                <TableRow key={`dailyPointInformationModal-${row.id}`} hover>
                  {isMobileDisplay ? (
                    <TableCell
                      sx={{
                        padding: "0.4rem .6rem",
                        margin: "0",
                        width: "100%",
                        display: "flex",
                      }}
                    >
                      <Grid container direction="column">
                        {renderKpiRow(row)}
                      </Grid>
                    </TableCell>
                  ) : (
                    <>
                      <TableCell
                        sx={{
                          padding: "0.4rem .6rem",
                          margin: "0",
                          width: "100%",
                          display: "flex",
                        }}
                      >
                        <MDBadgeDot
                          size="lg"
                          sx={{
                            ml: 1,
                            p: 0,
                            i: {
                              background: generateColorFromString(row?.KpiActivity?.name),
                            },
                          }}
                          badgeContent=""
                        />
                        {row?.KpiActivity?.name}
                      </TableCell>
                      {showCountAndPoints && (
                        <>
                          <TableCell sx={{ padding: "0.4rem .3rem", width: "10%" }} align="center">
                            {row?.count}
                          </TableCell>
                          <TableCell
                            width="10%"
                            sx={{ padding: "0.4rem .3rem", width: "10%" }}
                            align="center"
                          >
                            {row?.points}
                          </TableCell>
                          <TableCell
                            width="10%"
                            sx={{ padding: "0.4rem .3rem", width: "10%" }}
                            align="center"
                          >
                            {row?.max_points_per_day}
                          </TableCell>
                        </>
                      )}
                    </>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <MDBox sx={{ display: "flex", justifyContent: "end" }}>
          <MDButton
            color="gray80"
            onClick={handleClose}
            sx={{ mt: 2, mr: 1, position: "relative" }}
          >
            Close
          </MDButton>
        </MDBox>
      </MDBox>
    </Modal>
  );
}

export default DailyPointsInformationModal;
